/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/cart' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../../CacheDataRoute';
import BarMenuCart from '@routes/BarMenu/stages/BarMenuCart';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/cart/')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/cart',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuCart} path='/bar-menu/:barId/:tableId/cart' />
  )
});
